document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    loadData()
    
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    loadData();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    loadData();
});
$(document).ready(function(){
    loadData();
})
function loadData() {
    var products = sessionStorage.getItem(document.location.hostname+'-products');
    if (!products) {
        $.getJSON('/user/documents/products.json?v=?1-'+new Date().getHours(), function(data) {
            sessionStorage.setItem(document.location.hostname+'-products', JSON.stringify(data));
            customProduct(data);
        });
    } else {
        customProduct(JSON.parse(products));
    }
}


function customProduct(data) {
    $('.product').each(function() {
        var sku = $(this).find('span[data-micro="sku"]').text();
        var productData = data.find(p => p.code === sku);
        var basicLink = $(this).find('a.image').attr('href')
        $(this).attr('data-avail', $(this).find('.availability>span:not(.availability-amount)').text().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, ''));
        $(this).find('.p').append('<span class="btn_toggle"></span>');

        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }

        if (!$(this).find('.friends').length) {
            $(this).find('.ratings-wrapper').prepend('<div class="friends"></div>');
        }

        if (productData && productData.alternativa) {
            var alternativaCodes = productData.alternativa.split(';').filter(code => code);
            var maxVisible = 4;
            var additionalShown = false;
            var visibleCount = 0; // Počítadlo viditelných a dostupných položek
        
            alternativaCodes.forEach((code, index) => {
                var alternativaData = data.find(p => p.code === code);
                
                if (alternativaData && alternativaData.productVisibility === 'visible' && alternativaData.dostupnost > 0) {
                    // Pokud položka splňuje podmínky viditelnosti a dostupnosti, zvýší se viditelné položky
                    if (visibleCount < maxVisible) {
                        if(typeof alternativaData.defaultImage !== 'undefined'){
                            $(this).find('.friends').append('<div class="friend hasImage" data-avail="'+alternativaData.dostupnost+'" data-image="'+alternativaData.defaultImage.replace('/orig/', '/detail/')+'"><span class="show-tooltip" title="' + alternativaData.tooltip + '" data-original-title="' + alternativaData.tooltip + '"><img src="' + alternativaData.defaultImage.replace('/orig/', '/detail/') + '" alt="' + alternativaData.tooltip + '"></span></div>');
                        }
                        visibleCount++; // Zvýší počítadlo viditelných položek
                    } else if (!additionalShown) {
                        var remainingCount = alternativaCodes.length - visibleCount;
                        var moreText = remainingCount < 5 ? 'další' : 'dalších';
                        
                        $(this).find('.friends').append('<div class="friend"><a href="'+basicLink+'">+ '+remainingCount+' '+moreText+'</a></div>');
                        additionalShown = true;
                    }
                }
            });
        }
    });
    initTooltips();
}

$(document).ready(function() {
    var isTouchDevice = false;
    if ('ontouchstart' in window || navigator.maxTouchPoints) {
        isTouchDevice = true;
    }
    if (isTouchDevice) {
        $(document).on("mouseenter", '.friend.hasImage', function() {
            var img = $(this).attr('data-image');
            if(img) {
                $(this).closest('.product').find('.image img').attr('src', img.replace('/orig/', '/detail/'));
            }
        })
        $(document).on("mouseleave", '.friend.hasImage', function() {
            var img = $(this).closest('.product').find(' a.image img').attr('data-src');
            if(img) {
                $(this).closest('.product').find('.image img').attr('src', img);
            }
        })

    } else {
        $(document).on("mouseenter", '.friend.hasImage', function() {
            var img = $(this).attr('data-image');
            if(img) {
                $(this).closest('.product').find('.image img').attr('src', img.replace('/orig/', '/detail/'));
            }
        })
        $(document).on("mouseleave", '.friend.hasImage', function() {
            var img = $(this).closest('.product').find(' a.image img').attr('data-src');
            if(img) {
                $(this).closest('.product').find('.image img').attr('src', img);
            }
        })
    }
});